import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Views/Home";
import Services from "./Views/Services";
import Navbar from "./components/Navbar";
import Contact from "./Views/Contact";
import About from "./Views/About";
import Chatbot from "./components/Chatbot"; // Add this import

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Chatbot /> {/* Add chatbot here */}
      </div>
    </Router>
  );
}

export default App;
